<template>
  <v-container grid-list-md page>
    <v-flex>
      <h1 class="title primary--text mb-4">お客様情報</h1>

      <v-card>
        <v-card-text>
          <h2 class="title">{{ users.name01 }} {{ users.name02 }}様 / {{ users.name01_2 }} {{ users.name02_2 }}様</h2>

          <v-card-title class="mt-4">
            <div class="title">基本情報</div>
            <!--
            <v-spacer></v-spacer>
            <v-btn flat icon color="primary" @click.stop="edit1 = true">
              <v-icon>edit</v-icon>
            </v-btn>
            -->
          </v-card-title>
          <v-layout row wrap>
            <v-flex xs12 sm3>
              <v-subheader>お客様ID</v-subheader>
            </v-flex>
            <v-flex xs12 sm9>
              <v-text-field v-model="users.customer_login_id" disabled></v-text-field>
            </v-flex>
            <v-flex xs12 sm3>
              <v-subheader>挙式日</v-subheader>
            </v-flex>
            <v-flex xs12 sm9>
              <v-menu
                :disabled="!edit1"
                lazy
                :close-on-content-click="false"
                v-model="menu"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-right="40"
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  disabled
                  slot="activator"
                  v-model="users.wedding_date"
                  @blur="date = parseDate(users.wedding_date)"
                ></v-text-field>
                <v-date-picker v-model="date" @input="menu = false" locale="jap" no-title scrollable actions></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm3>
              <v-subheader>挙式会場</v-subheader>
            </v-flex>
            <v-flex xs12 sm9>
              <v-text-field v-model="users.hall_name" disabled></v-text-field>
            </v-flex>
            <!--
            <transition name="slide-fade">
              <div v-if="edit1">
                <v-btn color="primary" outline type="submit" @click="edit1 = false">キャンセル</v-btn>
                <v-btn color="info" outline type="submit" @click="updateCustomerInfo()">変更</v-btn>
              </div>
            </transition>
            -->
          </v-layout>

          <v-card-title class="mt-4">
            <div class="title">メールアドレス</div>
            <v-spacer></v-spacer>
            <v-btn flat icon color="primary" @click.stop="edit2 = true">
              <v-icon>edit</v-icon>
            </v-btn>
          </v-card-title>
          <v-layout row wrap>
            <v-flex xs12 sm3>
              <v-subheader>新郎メールアドレス</v-subheader>
            </v-flex>
            <v-flex xs12 sm9>
              <v-text-field v-model="users.email" prepend-icon="mail" :disabled="!edit2"></v-text-field>
            </v-flex>
            <v-flex xs12 sm3>
              <v-subheader>新婦メールアドレス</v-subheader>
            </v-flex>
            <v-flex xs12 sm9>
              <v-text-field v-model="users.email_bride" prepend-icon="mail" :disabled="!edit2"></v-text-field>
            </v-flex>
            <transition name="slide-fade">
              <div v-if="edit2">
                <v-btn color="primary" outline type="submit" @click="edit2 = false">キャンセル</v-btn>
                <v-btn color="info" outline type="submit" @click="updateCustomerEmail()">変更</v-btn>
              </div>
            </transition>
          </v-layout>
          <v-card-title class="mt-4">
            <div class="title">パスワード</div>
            <v-spacer></v-spacer>
            <v-btn flat icon color="primary" @click.stop="edit3 = true">
              <v-icon>edit</v-icon>
            </v-btn>
          </v-card-title>
          <v-layout row wrap>
            <v-flex xs12 sm3 v-if="edit3">
              <v-subheader>パスワード</v-subheader>
            </v-flex>
            <v-flex xs12 sm9 v-if="edit3">
              <v-text-field
                name="newpassword"
                label="現在のパスワード"
                required
                v-model="password.current"
                :append-icon="c1 ? 'visibility' : 'visibility_off'"
                :append-icon-cb="() => (c1 = !c1)"
                :type="c1 ? 'password' : 'text'"
                prepend-icon="lock"
              ></v-text-field>

              <v-text-field
                name="newpassword"
                label="新しいパスワード"
                required
                v-model="password.newpassword"
                :append-icon="p1 ? 'visibility' : 'visibility_off'"
                :append-icon-cb="() => (p1 = !p1)"
                :type="p1 ? 'password' : 'text'"
                prepend-icon="lock"
              ></v-text-field>

              <v-text-field
                name="confirm"
                label="確認用"
                required
                v-model="password.confirm"
                :append-icon="p2 ? 'visibility' : 'visibility_off'"
                :append-icon-cb="() => (p2 = !p2)"
                :type="p2 ? 'password' : 'text'"
                prepend-icon="lock"
              ></v-text-field>
            </v-flex>
            <div v-if="edit3">
              <v-btn color="primary" outline type="submit" @click="edit3 = false">キャンセル</v-btn>
              <v-btn color="info" outline type="submit" @click="updatePassword()">変更</v-btn>
            </div>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
import UserService from '@/components/services/UserService.vue'
export default {
  name: 'Info',
  data () {
    return {
      status: this.$store.state.snack_bar,
      edit1: false,
      edit2: false,
      edit3: false,
      c1: true,
      p1: true,
      p2: true,
      date: null,
      menu: false,
      users: {
        customer_login_id: null,
        wedding_date: null,
        hall_name: null,
        email: null,
        email_bride: null
      },
      password: {
        current: null,
        newpassword: null,
        confirm: null
      }
    }
  },
  created () {
    this.getCustomer()
  },
  watch: {
    date (val) {
      this.users.wedding_date = this.formatDate(this.date)
    }
  },
  methods: {
    /**
     * 新郎新婦情報
     **/
    getCustomer () {
      this.logging('methods: getCustomer')
      var transactionid = this.$store.state.transactionId
      UserService.findCustomer(transactionid, (response) => {
        this.users = response
        this.users.wedding_date = this.formatDate(this.users.wedding_date)
        console.log(this.users)
      }, (error) => {
        this.logging(error)
      })
    },
    /**
     * 新郎新婦情報の更新
     **/
    updateCustomerInfo () {
      this.logging('methods: updateCustomerInfo')
      console.log(this.users)
      const date = this.users.wedding_date
      /* eslint-disable-next-line */
      if (!/^\d{1,4}(\/|-)\d{1,2}\1\d{1,2}$/.test(date)) {
        alert('日付の形式が正しくありません。')
        return false
      }

      let params = new URLSearchParams()
      params.append('transactionid', this.$store.state.transactionId)
      params.append('wedding_date', this.users.wedding_date)
      UserService.updateCustomerInfo(params, (response) => {
        this.logging(response)
        this.status.changeInfoDia = true
        this.edit1 = false
      }, (error) => {
        this.logging(error)
        this.status.errorDia = true
      })
    },
    /**
     * 新郎新婦のメールアドレスを更新
     **/
    updateCustomerEmail () {
      this.logging('methods: updateCustomerInfo')
      console.log(this.users)
      let params = new URLSearchParams()
      params.append('transactionid', this.$store.state.transactionId)
      params.append('email', this.users.email)
      params.append('email_bride', this.users.email_bride)
      UserService.updateCustomerInfo(params, (response) => {
        this.logging(response)
        this.status.changeInfoDia = true
        this.edit2 = false
      }, (error) => {
        this.logging(error)
        this.status.errorDia = true
      })
    },
    /**
     * 日付データのフォーマットを整える
     **/
    formatDate (date) {
      if (!date) {
        return null
      }
      console.log(date)
      return date
    },
    parseDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    /**
     * 新郎新婦情報の更新
     **/
    updatePassword () {
      this.logging('methods: updatePassword')
      if (this.password.current !== null && this.password.newpassword !== null && this.password.confirm !== null) {
        let params = new URLSearchParams()
        params.append('transactionid', this.$store.state.transactionId)
        params.append('password_now', this.password.current)
        params.append('password01', this.password.newpassword)
        params.append('password02', this.password.confirm)
        UserService.updatePassword(params, (response) => {
          this.logging(response)
          this.status.changeInfoDia = true
          this.edit3 = false
        }, (error) => {
          this.logging(error)
          this.status.errorDia = true
        })
      } else {
        console.log('パスワードの項目が全て入力されておりません')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/Info.vue